/**
 * 마일리지 국가몰 정책 — 한국몰 전용.
 *
 * ★user-service `MallCodes.allowsMileage` 의 규칙을 그대로 옮긴 것이다. 적립·사용은 BE 가 이미
 * 막고 있고, 관리자 수동 지급/차감도 BE 게이트로 거부된다(별도 저장소 작업). 여기 BO 가드는 그
 * 보조다 — API 거부를 받고 나서야 알게 되는 대신, 누르기 전에 막고 이유를 보여준다.
 *
 * ★모르면 막지 않는다: 회원 정보를 아직 못 불러왔거나 몰 값이 비어 있으면 허용으로 본다.
 * BE 가 최종 판정을 하므로 과차단으로 정상 지급을 막는 쪽이 더 나쁘다(BE 의 allowsMileage 헬퍼도
 * 조회 실패 시 허용으로 폴백한다). 화면은 "확실히 해외몰일 때만" 비활성화한다.
 */

/** 마일리지를 쓸 수 있는 유일한 몰. */
export const MILEAGE_ALLOWED_MALL = 'ko-KR';

/** 이 몰의 회원에게 마일리지 지급/차감이 가능한지. 값이 없으면(미조회 등) 허용으로 본다. */
export const isMileageAllowedForMall = (mallCode: string | null | undefined): boolean => {
  if (mallCode == null || mallCode.trim() === '') return true;
  return mallCode.trim().toLowerCase() === MILEAGE_ALLOWED_MALL.toLowerCase();
};

/** 해외몰이라 차단해야 하는 상태인지(= 몰 값이 있고 한국몰이 아님). */
export const isOverseasMallMember = (mallCode: string | null | undefined): boolean =>
  !isMileageAllowedForMall(mallCode);
